import actions from './moduleExamsActions'

export default {
  isRegistered: false,
  namespaced: true,
  actions,
}
